import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { AdminPageHeader } from "@/components/admin/admin-shell";
import { CrudManager } from "@/components/admin/crud-manager";
import { adminList } from "@/lib/admin";
import { categories } from "@/lib/data";

export const Route = createFileRoute("/_authenticated/admin/brendler")({
  component: Page,
});

function Page() {
  const { data: brands } = useQuery({
    queryKey: ["admin", "brands"],
    queryFn: () => adminList("brands", "sort_order", true),
  });

  const brandOptions = (brands ?? []).map((b) => ({
    value: String(b["id"]),
    label: String(b["name"]),
  }));
  const brandName = (id: unknown) =>
    brandOptions.find((o) => o.value === String(id))?.label ?? "—";

  return (
    <div className="space-y-10">
      <div>
        <AdminPageHeader title="Brendlər" description="Kateqoriyalara aid brend siyahısı" />
        <CrudManager
          table="brands"
          orderColumn="sort_order"
          ascending
          addLabel="Yeni brend"
          emptyText="Brend yoxdur."
          fields={[
            { name: "name", label: "Brend adı" },
            { name: "slug", label: "Qısa ünvan (slug)" },
            {
              name: "category_slug",
              label: "Kateqoriya",
              type: "select",
              options: categories.map((c) => ({ value: c.slug, label: c.name })),
            },
            { name: "sort_order", label: "Sıra", type: "number" },
            { name: "active", label: "Aktiv", type: "boolean" },
          ]}
          columns={[
            { name: "name", label: "Brend" },
            { name: "category_slug", label: "Kateqoriya" },
            { name: "sort_order", label: "Sıra" },
            {
              name: "active",
              label: "Vəziyyət",
              render: (r) => (r["active"] ? "Aktiv" : "Deaktiv"),
            },
          ]}
        />
      </div>

      <div>
        <AdminPageHeader title="Modellər" description="Seçilmiş brendə aid model siyahısı" />
        <CrudManager
          table="brand_models"
          orderColumn="sort_order"
          ascending
          addLabel="Yeni model"
          emptyText="Model yoxdur."
          fields={[
            { name: "name", label: "Model adı" },
            { name: "brand_id", label: "Brend", type: "select", options: brandOptions },
            { name: "sort_order", label: "Sıra", type: "number" },
            { name: "active", label: "Aktiv", type: "boolean" },
          ]}
          columns={[
            { name: "name", label: "Model" },
            { name: "brand_id", label: "Brend", render: (r) => brandName(r["brand_id"]) },
            { name: "sort_order", label: "Sıra" },
            {
              name: "active",
              label: "Vəziyyət",
              render: (r) => (r["active"] ? "Aktiv" : "Deaktiv"),
            },
          ]}
        />
      </div>
    </div>
  );
}
